import { Component, OnInit } from '@angular/core';
import { NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'cx-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    standalone: true,
    imports: [NgIf, TranslateModule]
})
export class SpinnerComponent implements OnInit {
  message: any;
  constructor() { }

  ngOnInit(): void {
  }

}
